import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const IndexReceptionPage = lazyWithRetry(() => import("./IndexReceptionPage"));

// one page, three routes: the tabs are links, so a tab is shareable and the
// back button walks them (the page picks its tab from the path)
export default [
  <Route
    exact
    path="/reception"
    key="reception-index"
    component={IndexReceptionPage}
  />,
  <Route
    exact
    path="/reception/today"
    key="reception-today"
    component={IndexReceptionPage}
  />,
  <Route
    exact
    path="/reception/history"
    key="reception-history"
    component={IndexReceptionPage}
  />,
];
